import { RecaptchaVerifier } from 'firebase/auth'
import { getFirAuth } from '../../Api/firebase/firebaseConnect'
import { ANALYTICS_TAGS } from '../../Constant'
import { handleAuthError, logEvent } from '../index'

/**
 * Cache for reCAPTCHA verifiers
 */
export const VERIFIER_CACHE = new Map<string, RecaptchaVerifier>()

/**
 * Create reCAPTCHA verifier
 */
export const createRecaptchaVerifier = async (
  containerId: string,
  onSolved?: () => void
): Promise<RecaptchaVerifier> => {
  const auth = await getFirAuth()
  if (!auth) {
    throw new Error('Auth instance not available for reCAPTCHA verifier')
  }

  return new RecaptchaVerifier(auth, containerId, {
    size: 'invisible',
    callback: (response: string) => {
      if (onSolved) onSolved()
    },
    'expired-callback': () => {
      logEvent(ANALYTICS_TAGS.recaptcha_expired, {
        element: containerId,
        product: 'web',
      })
    },
    'error-callback': (error: any) => {
      handleAuthError(ANALYTICS_TAGS.recaptcha_error, error, 'recaptcha_error_callback')
    },
  })
}

/**
 * Get cached verifier or create new one
 */
export const getOrCreateVerifier = async (
  containerId: string,
  onSolved?: () => void
): Promise<RecaptchaVerifier> => {
  let verifier = VERIFIER_CACHE.get(containerId)

  if (!verifier) {
    verifier = await createRecaptchaVerifier(containerId, onSolved)
    VERIFIER_CACHE.set(containerId, verifier)
  }

  return verifier
}
